<template>
  <div class="box">
    <div class="operation">
      <el-form ref="form" :model="form" label-width="80px" class="form" :inline="true">
        <el-form-item label="产品类型" label-position="right" class="mt">
          <el-select v-model="form.type" placeholder="请选择" clearable>
            <el-option label="ZPOS-电签" value="1"></el-option>
            <el-option label="FPOS-大机" value="2"></el-option>
            <el-option label="ZPOS-买断版" value="3"></el-option>
            <el-option label="FPOS-买断版" value="4"></el-option>
            <el-option label="和融通" value="5"></el-option>
            <el-option label="合利宝" value="6"></el-option>
            <el-option label="电银" value="7"></el-option>
            <el-option label="联动支付" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SN号" label-position="right" class="mt">
          <el-input v-model="form.snCodes" size="small" placeholder="请输入SN号" clearable></el-input>
        </el-form-item>
        <el-form-item label="绑定状态" label-position="right" class="mt">
          <el-select v-model="form.bindingState" placeholder="请选择" clearable>
            <el-option label="未绑定" value="0"></el-option>
            <el-option label="已绑定" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="激活状态" label-position="right" class="mt">
          <el-select v-model="form.activeState" placeholder="请选择" clearable>
            <el-option label="未激活" value="0"></el-option>
            <el-option label="已激活" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否达标" label-position="right" class="mt">
          <el-select v-model="form.isCompliance" placeholder="请选择" clearable>
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="mt">
        <el-button type="primary" class="btn" @click="queryFunc" icon="el-icon-search">查询</el-button>
        <el-button class="btn" @click="clearFunc" icon="el-icon-delete">重置</el-button>
        <el-upload class="upload-demo btn" multiple action="string" :accept="'.xlsx, .xls'" :before-upload="beforeUpload"
          :on-error="onError" :show-file-list="false" :http-request="onSuccess">
          <el-button type="primary" icon="el-icon-plus" class="btn">设备导入</el-button>
        </el-upload>
        <!--                <el-button type="primary" class="btn" @click="pullDown" :disabled="isDisabled">下拨</el-button>-->
        <el-button type="primary" class="btn" @click="callBack" :disabled="isDisabled">回拨</el-button>
        <el-button type="primary" class="btn" @click="unBind">解绑</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tabBox">
      <el-table ref="selections" :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange"
        style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="snCode" label="设备SN号">
        </el-table-column>
        <el-table-column label="产品类型" prop="receiptType">
          <template slot-scope="scope">
            <span v-if="scope.row.receiptType == 1">ZPOS-电签</span>
            <span v-if="scope.row.receiptType == 2">FPOS-大机</span>
            <span v-if="scope.row.receiptType == 3">ZPOS-买断版</span>
            <span v-if="scope.row.receiptType == 4">FPOS-买断版</span>
            <span v-if="scope.row.receiptType == 5">和融通</span>
            <span v-if="scope.row.receiptType == 6">合利宝</span>
            <span v-if="scope.row.receiptType == 7">电银</span>
            <span v-if="scope.row.receiptType == 8">联动支付</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="会员名称" sortable>
        </el-table-column>
        <el-table-column label="编号">
          <template slot-scope="scope">
            <span>{{ scope.row.userCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定状态/绑定时间">
          <template slot-scope="scope">
            <!-- 展示商户绑定状态 -->
            <span>{{ scope.row.bindingState == '0' ? '未绑定' : '已绑定' }}</span>
            &nbsp;
            <!-- 展示商户绑定时间 -->
            <span v-if="scope.row.bindingState == '1'">/&nbsp;{{ scope.row.bindingTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备激活/激活时间">
          <template slot-scope="scope">
            <!-- 展示设备激活 -->
            <span>{{ scope.row.activeState == '0' ? '未激活' : '已激活' }}</span>
            &nbsp;
            <!-- 展示激活时间 -->
            <span v-if="scope.row.activeState == '1'">/&nbsp;{{ scope.row.activeTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否达标">
          <template slot-scope="scope">
            <!-- 展示设备激活 -->
            <span>{{ scope.row.isCompliance == '0' ? '否' : '是' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link :underline="false" type="Info" @click="goDetail(scope.row)">查看</el-link>
            <!--                        <el-link :underline="false" type="primary" @click="getDown(scope.row.snCode)"-->
            <!--                            v-if="scope.row.bindingState == '0'">下拨</el-link>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationBox">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagelndex"
        :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination">
      </el-pagination>
    </div>
    <AddView :message="dialogFormVisible" @closeFunction='getDialogFormVisible' @add-success="equipmentLisrFunc"
      :snNums="snCodes">
    </AddView>
    <CallBack :callBackMessage="dialogValue" @closeFunction="changeDialogValue" :snNums="snCodes"></CallBack>
    <Unbind :callBackMessage="dialogValueUnbind" @closeFunction="changeDialogValue" :snNums="snCodes"></Unbind>
  </div>
</template>

<script>
  import AddView from './components/AddView.vue';
  import CallBack from './components/CallBack.vue';
  import Unbind from './components/Unbind.vue';
  import equipmentApi from '@/api/equipment/messagecontrol.js'
  export default {
    data() {
      return {
        form: {
          type: '', // 产品类型
          snCodes: '', // SN号
          bindingState: '', // 跳转方式（0：外部链接；1：内部链接；2:图文内容）
          activeState: '', // 状态
          isCompliance: '',
        },
        tableData: [],
        multipleSelection: [],
        loading: true, // 表格加载
        total: 0, // 总数
        pageSize: 10, // 条数
        pagelndex: 1, // 页数
        dialogFormVisible: false, // 下拨变量
        dialogValue: false, // 回拨变量
        dialogValueUnbind: false, //解绑
        isBind: false,
        selections: [],
        snCodes: "", // 存储SN号
        file: null
      }
    },
    components: {
      AddView,
      CallBack,
      Unbind
    },
    methods: {
      beforeUpload(file) {
        const isXlsx = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const isXls = file.type === 'application/vnd.ms-excel'

        if (!isXlsx && !isXls) {
          this.$message.error('只能上传xlsx和xls格式的文件')
          return false
        } else {
          this.file = file
        }
      },
      onSuccess() {
        // this.$message.success('上传成功！')
        // 上传成功后调用接口
        const formData = new FormData()
        formData.append('file', this.file)
        equipmentApi.addEquipment(formData).then(res => {
          this.$message.success(res.data)
          this.equipmentLisrFunc();
        }).catch(err => {
          // console.log(err)
        })
      },
      onError(err, file, fileList) {
        this.$message.error('上传失败！')
      },
      toggleSelection() {
        this.$refs.selections.clearSelection();
      },
      // 回拨
      changeDialogValue(value) {
        this.dialogValue = value;
        this.dialogValueUnbind = value;
        this.clearFunc();
      },
      unBind() {
        if (this.selections.length == 0) {
          this.$message({
            type: 'warning',
            message: '至少选择一个设备进行解绑'
          });
          return;
        }
        this.dialogValueUnbind = true;
      },
      callBack() {
        if (this.selections.length == 0) {
          this.$message({
            type: 'warning',
            message: '至少选择一个设备进行回拨'
          });
          return;
        }
        this.dialogValue = true;
      },
      // 下拨
      getDialogFormVisible(value) {
        this.dialogFormVisible = value;
      },

      /*打开详情*/
      goDetail(row) {
        let self = this;
        let params = row.deviceId;
        self.$router.push({
          path: '/equipment/messagecontrol/Detail',
          query: {
            deviceId: params
          }
        });
      },
      handleSelectionChange(val) {
        this.selections = val;
        this.snCodes = (this.selections.map(item => item.snCode)).join(',');
        console.log(this.snCodes);
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.equipmentLisrFunc();
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.pageIndex = val;
        this.equipmentLisrFunc();
      },
      // 渲染列表
      equipmentLisrFunc() {
        // console.log(this.form.type)
        const params = {
          type: this.form.type,
          snCodes: this.form.snCodes,
          bindingState: this.form.bindingState,
          activeState: this.form.activeState,
          isCompliance: this.form.isCompliance,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        }
        equipmentApi.getEquipmentList({ ...params
        }).then(res => {
          // console.log(res)
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false;
        }).catch(err => {
          // console.log(err);
        })
      },
      // 查询按钮
      queryFunc() {
        this.equipmentLisrFunc();
      },
      // 重置
      clearFunc() {
        this.form.type = '';
        this.form.snCodes = '';
        this.form.bindingState = '';
        this.form.activeState = '';
        this.form.isCompliance = '';
        this.equipmentLisrFunc();
      },
      // 下拨
      pullDown() {
        if (this.selections.length == 0) {
          this.$message({
            type: 'warning',
            message: '至少选择一个设备进行下拨'
          });
          return;
        }
        this.dialogFormVisible = true;
      },
      getDown(val) {
        // if (val) {
        this.snCodes = val;
        this.dialogFormVisible = true;
        // }

      }
    },
    mounted() {
      this.equipmentLisrFunc();
    },
    computed: {
      isDisabled() {
        // 如果选中项中有任一项的 bindingState 是已绑定，则禁用按钮；反之则可以点击使用
        if (this.selections.length === 0) {
          // 没有选中项时，按钮禁用
          return false;
        }
        const hasBoundDevice = this.selections.some(item => item.bindingState === '1');
        if (hasBoundDevice) {
          // 有已绑定设备时，按钮禁用
          return true;
        }
        // const hasUnboundDevice = this.selections.some(item => item.bindingState === '0');
        // if (!hasUnboundDevice) {
        //     // 所有设备都未绑定时，按钮禁用
        //     return false;
        // }

        // 其他情况，按钮可以使用
        return false;
      }
    },
    watch: {
      dialogFormVisible: function(newVal, oldVal) {
        if (!newVal && oldVal) {
          this.snCodes = "";
          this.toggleSelection()
        }
      },
      dialogValue: function(newVal, oldVal) {
        if (!newVal && oldVal) {
          this.snCodes = "";
          this.toggleSelection()
        }
      },
      val: {
        handler(newVal) {
          newVal.forEach(item => {
            if (item.bindingState == '1') {
              this.isBind = true;
              // console.log(this.isBind)
            } else {
              this.isBind = false
              // console.log(this.isBind)
            }
          })
          // console.log('val 发生了变化', newVal, oldVal);
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .mt {
    margin-top: 20px
  }

  .tabBox {
    margin: 40px 0;
  }

  .box {
    padding: 10px;
  }



  .form {
    margin-right: 20px;
  }

  .btn {
    margin-left: 15px;
    display: inline-block
  }

  .el-form-item {
    margin-bottom: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/equipment/messagecontrol/index.vue